<template>
  <div style="margin-top: 60px;">
    <van-tabbar v-model="active">
      <van-tabbar-item icon="add-o">新建预约</van-tabbar-item>
      <van-tabbar-item icon="home-o">我的预约</van-tabbar-item>
      <van-tabbar-item icon="sign">现场签到</van-tabbar-item>
    </van-tabbar>
    <van-nav-bar title="诺宝健身预约助手" />
    <div v-if="active==0">
      <van-field readonly clickable
        name="calendar" :value="date" label="健身的日期"
        placeholder="选择日期" @click="show = true"
      />
      <div v-if="dataReady">
        <van-calendar v-model="show" :max-date="upLimitDay"
          @confirm="onConfirm" :show-confirm="false"
          :formatter="formatter" />
      </div>
      <van-field name="radio" label="选择时间段">
        <template #input>
          <van-radio-group v-model="slot" direction="horizontal">
            <van-radio name="白天">白天</van-radio>
            <van-radio name="晚上">晚上</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <div style="margin: 16px;">
        <van-button type="primary" size="large" block round @click="onBooking()">预约</van-button>
      </div>
    </div>
    <div v-if="active==1">
      <van-checkbox-group v-model="result">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in bookingList"
            clickable
            :key="item"
            :title="item"
            @click="toggle(index)"
          >
            <van-checkbox slot="right-icon" :name="item" ref="checkboxes" />
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      <div style="margin: 16px;">
        <van-button type="danger" size="large" block round @click="delBooking()">取消预约</van-button>
      </div>
    </div>
    <div v-if="active==2">
      <van-icon name="user-o" size="4rem" v-if="!checkInOK && !finalFail"/>
      <div v-if="checkInOK" style="vertical-align: middle;">
        <van-icon name="/static/big_suc.png" size="10rem"/>
        <div class="van-ellipsis" style="font-size: 35px;">签到成功!</div>
        <div class="van-ellipsis" style="font-size: 30px;">工号: #{{cecCode}}</div>
        <div class="van-ellipsis" style="font-size: 25px;">日期: {{nowTime}}</div>
      </div>
      <div v-if="!checkInOK && !useQrCheckIn">
        <van-loading type="spinner" size="5rem"/>
      </div>
      <div style="margin: 16px;" v-if="useQrCheckIn && !checkInOK && !finalFail">
        <van-button type="primary" size="large" block round @click="qrCodeCheckin()">扫码签到</van-button>
      </div>
      <div v-if="finalFail">
        <van-icon name="cross" size="10rem"/>
        <div class="van-ellipsis" style="font-size: 35px;">签到失败!</div>
        <div class="van-ellipsis" style="font-size: 30px;">{{errorReason}}</div>
        <div class="van-ellipsis" style="font-size: 25px;">日期: {{nowTime}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { Calendar, Cell, Button, Dialog,
         NavBar, Toast, RadioGroup, Radio,
         Form, Tabbar, TabbarItem, List,
         Loading } from 'vant';

export default {
    name: 'Fitness',
    data () {
      return {
        date: '',
        show: false,
        slot: '晚上',
        bookingResult: '预约成功',
        active: 0,
        upLimitDay: '',
        remaining: {},
        dataReady: false,
        chosenBookingId: '0',
        bookingList: [
          '2020-03-10 白天',
          '2020-03-20 晚上',
          '2020-03-21 白天'
        ],
        result: [],
        useQrCheckIn: false,
        checkInOK: false,
        loadingToast: null,
        cecCode: "000000",
        nowTime: "1900-01-01 00:00",
        finalFail: false,
        errorReason: ""
      }
    },
    mounted() {
      this.requestJSSDK();
    },
    created() {
      this.updateRemaining();
    },
    methods: {
      updateRemaining() {
        var vm = this;
        var today = new Date();
        this.upLimitDay = new Date(today.getTime() + (24 * 60 * 60 * 1000) * 3);
        axios.get('/api/fitnessStat', {
          params: {
            'start': this.formatDate(today),
            'end': this.formatDate(this.upLimitDay)
          }
        }).then((res) => {
          console.log(res.data);
          vm.remaining = res.data;
          vm.dataReady = true;
        }).catch((error) => {
          alert("Internal server error!");
          vm.remaining = {};
          vm.dataReady = false;
        });
      },
      formatter(day) {
        let keyDate = this.formatDate(day.date);
        if (keyDate in this.remaining) {
          //console.log("key date:", keyDate);
          day.topInfo = "白天:" + this.remaining[keyDate]['dayRemaining'];
          day.bottomInfo = "晚上:" + this.remaining[keyDate]['nightRemaining'];
        }
        return day;
      },
      qrCodeCheckin() {
        const vm = this;
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: (res) => {
            //alert('您扫描成功,追溯码为:' + res.resultStr);
            var uOpenid = sessionStorage.getItem('openid');
            var resList = res.resultStr.split('|');
            if (resList.length !== 2) {
              vm.checkInOK = false;
              vm.cecCode = "000000";
              vm.nowTime = new Date().toLocaleString();
              vm.errorReason = "二维码格式无效，请联系现场工作人员!";
              vm.finalFail = true;
              return;
            }
            //alert("lat:" + lat.toString() + ",lng:" + lng.toString());
            axios.put('/api/fitbook', {
              openid: uOpenid,
              lat: resList[0],
              lng: resList[1],
              precision: -5.0
            }).then((res) => {
              console.log(res);
              if (res.data == "E_BOOK") {
                vm.checkInOK = false;
                vm.finalFail = true;
                vm.errorReason = "没有找到您的预约!";
              } else if (res.data == "E_CECID") {
                vm.checkInOK = false;
                vm.finalFail = true;
                vm.errorReason = "您没有访问权限!";
              } else if (res.data == "E_CHECK") {
                vm.checkInOK = false;
                vm.finalFail = true;
                vm.errorReason = "您已签到,不能重复签到!";
              } else {
                vm.checkInOK = true;
                vm.cecCode = res.data;
              }
              vm.nowTime = new Date().toLocaleString();
            }).catch((error) => {
              console.log(error);
              vm.checkInOK = false;
              vm.cecCode = "000000";
              vm.nowTime = new Date().toLocaleString();
              vm.errorReason = error.response && error.response.status >= 500
                ? "签到服务异常，请稍后重试!"
                : "二维码签到失败，请联系现场工作人员!";
              vm.finalFail = true;
            });
          },
          error: (res) => {
            alert("二维码签到权限不足!");
            vm.finalFail = true;
          }
        });
      },
      gpsCheckin() {
        const vm = this;
        wx.getLocation({
          type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: (res) => {
            var uOpenid = sessionStorage.getItem('openid');
            //alert("lat:" + lat.toString() + ",lng:" + lng.toString());
            axios.put('/api/fitbook', {
              openid: uOpenid,
              lat: res.latitude,
              lng: res.longitude,
              precision: res.accuracy
            }).then((res) => {
              console.log(res);
              vm.useQrCheckIn = false;
              if (res.data == "E_BOOK") {
                vm.checkInOK = false;
                vm.finalFail = true;
                vm.errorReason = "没有找到您的预约!";
              } else if (res.data == "E_CECID") {
                vm.checkInOK = false;
                vm.finalFail = true;
                vm.errorReason = "您没有访问权限!";
              } else if (res.data == "E_CHECK") {
                vm.checkInOK = false;
                vm.finalFail = true;
                vm.errorReason = "您已签到,不能重复签到!";
              } else {
                vm.checkInOK = true;
                vm.cecCode = res.data;
              }
              vm.nowTime = new Date().toLocaleString();
            }).catch((error) => {
              console.log(error);
              vm.useQrCheckIn = true;
              vm.checkInOK = false;
              vm.cecCode = "000000";
            });
          },
          error: (res) => {
            // 无法获取位置,改用二维码签到
            vm.useQrCheckIn = true;
            vm.checkInOK = false;
            vm.cecCode = "000000";
          }
        });
      },
      toggle(index) {
        this.$refs.checkboxes[index].toggle();
        console.log(this.result);
      },
      delEle(array, elem) {
        var index = array.indexOf(elem);
        if (index > -1) {
          array.splice(index, 1);
        }
      },
      delBooking() {
        var vm = this;
        Dialog.confirm({
          title: '警告',
          message: '确认取消预约?'
        }).then(() => {
          // on confirm
          var i;
          for (i = 0; i < vm.result.length; i++) {
            var bookDate = vm.result[i].substr(0, 10);
            var bookSlot = 0;
            if (vm.result[i].substr(-2) == '白天') {
              bookSlot = 1;
            }
            var uOpenid = sessionStorage.getItem('openid');
            axios.delete('/api/fitbook', {
              params: {
                date: bookDate,
                slot: bookSlot,
                openid: uOpenid
              }
            })
            .then((response) => {
              console.log("success");
            })
            .catch((error) => {
              alert("Internal server error!");
            });
            vm.delEle(vm.bookingList, vm.result[i]);
          }
        }).catch(() => {
          // on cancel
        });
      },
      onConfirm(date) {
        this.show = false;
        this.date = this.formatDate(date);
      },
      onBooking() {
        var vm = this;
        Dialog.confirm({
          title: '您预约了' + this.date + ' ' + this.slot + '的健身',
          message: '多次预约不去的员工,将失去这项福利!'
        }).then(() => {
          // on confirm
          var slot_code = 0;
          if (vm.slot == '白天') {
            slot_code = 1;
          }
          var uOpenid = sessionStorage.getItem('openid');
          axios.post('/api/fitbook', {
            date: vm.date,
            slot: slot_code,
            openid: uOpenid
          })
          .then((response) => {
            //console.log(response);
            Toast("预约成功!");
            vm.updateRemaining();
          })
          .catch((error) => {
            console.log(error.response.data);
            Toast(error.response.data.reason);
          });
        }).catch(() => {
          // on cancel
          vm.date = '';
          vm.slot = '晚上';
        });
      },
      formatDate(date) {
        let m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return `${date.getFullYear()}-${m}-${d}`;
      },
      requestJSSDK() {
        const vm = this;
        const url = (window.location.href).split('#')[0];
        console.log(window.location.href, '这个是获取当前扫描的完整url');
        vm.loadingToast = Toast.loading({
          duration: 0,
          forbidClick: true,
          message: '加载中...'
        });
        axios.get('/api/sign', {
            params: {
              'url': url
            }
          }).then((res) => {
            vm.loadingToast.clear();
            console.log(res.data, '这个是获取调用扫描返回的参数?');
            //微信 的配置
            vm.wxConfig(
              res.data.appid,
              res.data.timestamp,
              res.data.noncestr,
              res.data.signature);
          }).catch((error) => {
            vm.loadingToast.clear();
            alert("无法获取基本操作权限!");
          }
        );
      },
      wxConfig(appId, timestamp, nonceStr, signature){
        wx.config({
          debug: false, // 开启调试模式,
          appId: appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature,// 必填，签名，见附录1
          jsApiList: [
            'scanQRCode',
            'checkJsApi',
            'getLocation',
            'hideAllNonBaseMenuItem',
            'hideOptionMenu'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          //禁用右上角菜单按钮
          wx.hideOptionMenu();
          wx.hideAllNonBaseMenuItem();
        });
        wx.error((res) => {
          alert("出错了：" + res.errMsg);//这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
        });
      }
    },
    watch: {
      active: function (val) {
        if (val == 0) {
          this.updateRemaining();
        } else if (val == 1) {
          var vm = this;
          var uOpenid = sessionStorage.getItem('openid');
          axios.get('/api/fitbook', {
            params: {
              'openid': uOpenid
            }
          }).then((res) => {
            var i;
            var slotName;
            vm.bookingList = [];
            for (i = 0; i < res.data.length; i ++) {
              if (res.data[i].slot == 1) {
                slotName = ' 白天';
              } else {
                slotName = ' 晚上';
              }
              vm.bookingList.push(res.data[i].date + slotName);
            }
          }).catch((error) => {
            vm.bookingList = [];
            alert("Internal server error!");
          });
        } else if (val == 2) {
          this.finalFail = false;
          this.gpsCheckin();
        }
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/Fitness.vue